import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PasswordSection({ token }) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ current: '', new_pw: '', confirm: '' });

  const handleChange = async () => {
    if (form.new_pw !== form.confirm) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }
    if (form.new_pw.length < 6) {
      toast.error('Le nouveau mot de passe doit contenir au moins 6 caractères');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/change-password`, {
        current_password: form.current,
        new_password: form.new_pw
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Mot de passe modifié avec succès');
      setForm({ current: '', new_pw: '', confirm: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors du changement de mot de passe');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card data-testid="change-password-card">
      <CardHeader>
        <div className="flex items-center gap-2">
          <KeyRound className="w-5 h-5 text-muted-foreground" />
          <CardTitle className="font-heading">Mot de passe</CardTitle>
        </div>
        <CardDescription>Modifiez votre mot de passe de connexion</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="current-password">Mot de passe actuel</Label>
          <Input
            id="current-password"
            type="password"
            placeholder="Votre mot de passe actuel"
            value={form.current}
            onChange={(e) => setForm({ ...form, current: e.target.value })}
            data-testid="current-password-input"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="new-password">Nouveau mot de passe</Label>
          <Input
            id="new-password"
            type="password"
            placeholder="Min. 6 caractères"
            value={form.new_pw}
            onChange={(e) => setForm({ ...form, new_pw: e.target.value })}
            data-testid="new-password-input"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="confirm-password">Confirmer</Label>
          <Input
            id="confirm-password"
            type="password"
            placeholder="Confirmez votre nouveau mot de passe"
            value={form.confirm}
            onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            data-testid="confirm-password-input"
          />
        </div>
        <Button
          onClick={handleChange}
          disabled={loading || !form.current || !form.new_pw || !form.confirm}
          data-testid="change-password-btn"
        >
          {loading ? 'Modification...' : 'Changer le mot de passe'}
        </Button>
      </CardContent>
    </Card>
  );
}
